import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { Alert, Dropdown, Modal, Tabs, Popover, Toggle, Slideover } from "tailwindcss-stimulus-components"
import LocalTime from "local-time"

import "../src/confirm"
import "../src/lazysrc"
import "../src/turbo_streams"

import ColoringController from "../controllers/coloring_controller"
import ColoringPagePrintController from "../controllers/coloring_page_print_controller"
import ImageGateController from "../controllers/image_gate_controller"
import LoadMoreController from "../controllers/load_more_controller"
import MasonryController from "../controllers/masonry_controller"
import ThemeController from "../controllers/theme_controller"
import TooltipController from "../controllers/tooltip_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("coloring", ColoringController)
application.register("coloring-page-print", ColoringPagePrintController)
application.register("image-gate", ImageGateController)
application.register("load-more", LoadMoreController)
application.register("masonry", MasonryController)
application.register("theme", ThemeController)
application.register("tooltip", TooltipController)
application.register("alert", Alert)
application.register("dropdown", Dropdown)
application.register("modal", Modal)
application.register("tabs", Tabs)
application.register("popover", Popover)
application.register("toggle", Toggle)
application.register("slideover", Slideover)

LocalTime.start()
